import {trigger} from "../../../utils/events/trigger";

export const initScroll = () => {
	window.addEventListener(`scroll`, (evt) => {
		//
		// add some function
		//
		// add some function
		// ...
		// etc.
	});

	trigger(window, `scroll`);
};
